import React from 'react';
import {CircleXIcon} from '@components/icon/CircleXIcon';

export default class WordList extends React.Component {
  render() {
    const {words, label = 'or'} = this.props;
    return (
      <ul className="word-list">
        {words.map((word, index) => (
          <li key={index}>
            {index > 0 && <label>{label}</label>}
            <input
              type="text"
              value={word}
              onChange={e => this.props.onWordChange(index, e.target.value)}
            />
            {index === words.size - 1 && (
              <div onClick={() => this.props.onWordChange(-1, '')} className="or-button">
                or
              </div>
            )}
            <div className="delete" onClick={() => this.props.removeWord(index)}>
              <CircleXIcon tooltip="Remove" />
            </div>
          </li>
        ))}
      </ul>
    );
  }
}
